import { Avatar, Link, Stack } from '@optimus-web/core';

export const GroupAvatar = ({ groupName, onClick }: { groupName: string; onClick: () => void }) => (
    <Stack spacing="100" itemAlignment="center" onClick={onClick}>
        <Avatar src="" alt={groupName} title={groupName} size="small" />
        <Link variant="basic" onClick={onClick}>
            {groupName}
        </Link>
    </Stack>
);
